import apiSdk from '@api-sdk';

/**
 * This is a segment event wrapper to avoid Ads blockers
 * The event data is send to our API v2 and we trigger segment event behind the scense
 * @param name
 * @param data
 */
export const segmentTrackApiWrapper = async (
  name: string,
  data: Record<string, unknown> = {}
) => {
  try {
    await apiSdk.postEvents({
      name,
      data,
    });
  } catch (e) {
    console.warn(
      `Unable to track the event ${name} via API v2 events wrapper endpoint`
    );
  }
};
